import type { CosmicVariationType } from '@/lib/cms/cosmic/types/CosmicProductType'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

type Props = {
  selectedVariation: CosmicVariationType | null
}

type Parameter = {
  key: string
  value: string | number
}

export const useProductVariationTypeQueryParams = ({
  selectedVariation,
}: Props) => {
  const router = useRouter()

  const addQueryParams = (params: Parameter[]) => {
    const newQuery = { ...router.query }
    for (const { key, value } of params) {
      newQuery[key] = String(value)
    }

    ;(async () => {
      await router.replace(
        {
          pathname: router.pathname,
          query: newQuery,
        },
        undefined,
        { shallow: true },
      )
    })()
  }
  // we could maybe we can memoize the addqueryparams?
  useEffect(() => {
    if (!router.isReady || !selectedVariation) return

    const selectedVariationSku = selectedVariation.sku.toString()

    if (selectedVariationSku) {
      addQueryParams([{ key: 'sku', value: selectedVariationSku }])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.isReady, selectedVariation])
}
